<template>
  <div :class="containerClasses">
    <div :class="spinnerClasses"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: {
    type: String,
    default: 'medium',
    validator: (value) => ['small', 'medium', 'large'].includes(value)
  },
  fullWidth: {
    type: Boolean,
    default: false
  },
  fullHeight: {
    type: Boolean,
    default: false
  },
  center: {
    type: Boolean,
    default: true
  }
})

const sizeMap = {
  small: 'w-2.5 h-2.5 border',
  medium: 'w-5 h-5 border',
  large: 'w-7 h-7 border-2'
}

const spinnerClasses = computed(() => {
  return [
    sizeMap[props.size],
    'border-gray-200 border-t-accent rounded-full animate-spin'
  ].join(' ')
})

const containerClasses = computed(() => {
  const classes = []

  if (props.fullWidth) {
    classes.push('w-full')
  }

  if (props.fullHeight) {
    classes.push('h-full')
  }

  if (props.center) {
    classes.push('flex flex-col items-center justify-center')
  } else {
    classes.push('flex flex-col items-center')
  }

  return classes.join(' ')
})
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 0.8s linear infinite;
}
</style>
